module.exports = __webpack_public_path__ + "img/cs-iosC-4.b228f6b0.jpg";